import React, { useEffect, useState } from 'react'
import Sidebar from '../Sidebar/Sidebar'
import Textbox from '../Textbox/Textbox'
import TextArea from '../TextArea/TextArea'
import Calender from '../Calender/Calender'
import html2pdf from 'html2pdf.js'
import { FaTrash } from 'react-icons/fa';

const Payslip = () => {

  const [payslipData, setPayslipData] = useState({
    title: 'Payslip',
    payslipNo: 'PS-001',
    employerDetails: '',
    employeeDetails: '',
    payDate: '',
    payPeriod: '',
    footerNote: 'This is system generated payslip',
    paymentDetails: 'Payment made to employees bank account',
    employeeSignatureText: '',
    employerSignatureText: '',
    currency: '\u20B9',
  })


  const [total, setTotal] = useState(0)
  const [imageUrl, setImageUrl] = useState(null)
  const months = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August',
    'September', 'October', 'November', 'December'
  ]
  const [numbersInWords, setNumbersInWords] = useState(0)

  // Define an object that maps numbers to their word form
  function convertNumberToWords(num) {
    if (num === 0) return "Zero";

    const ones = ["", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten", "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen", "Eighteen", "Nineteen"];
    const tens = ["", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety"];
    const thousands = ["", "Thousand", "Million", "Billion", "Trillion"];


    function convertChunk(num) {
      let result = "";

      if (num >= 100) {
        result += ones[Math.floor(num / 100)] + " hundred ";
        num %= 100;
      }

      if (num >= 20) {
        result += tens[Math.floor(num / 10)] + " ";
        num %= 10;
      }

      if (num > 0) {
        result += ones[num] + " ";
      }

      return result.trim();
    }

    let chunkIndex = 0;
    let words = "";

    while (num > 0) {
      let chunk = num % 1000;
      if (chunk > 0) {
        words = convertChunk(chunk) + (thousands[chunkIndex] ? " " + thousands[chunkIndex] : "") + " " + words;
      }
      num = Math.floor(num / 1000);
      chunkIndex++;
    }

    return words.trim();
  }


  useEffect(() => {
    setNumbersInWords(convertNumberToWords(total))
  }, [total])

  //it updates pay period on every intial render
  const date = new Date()
  useEffect(() => {
    setPayslipData((prev) => ({
      ...prev,
      payPeriod: `${months[date.getMonth()]} ${date.getFullYear()}`
    }))
  }, [])


  //it updates pay date on intial render 

  useEffect(() => {
    const today = new Date().toISOString().split('T')[0]
    setPayslipData((prev) => ({ ...prev, payDate: today }))
  }, [])


  //variable for earnings table

  const [earnings, setEarnings] = useState([
    { earnings: 'Basic Pay', amount: '' },
    { earnings: 'Overtime Pay', amount: '' },
  ]);

  //variabel for deductions table

  const [deductions, setDeductions] = useState([
    { deduction: 'Tax', amount: '' },
  ])



  //calculate total on every earnings and deductions changes 
  useEffect(() => {
    const totalEarnings = earnings.reduce((accumulator, current) => {
      return accumulator + new Number(current.amount || 0)
    }, 0)

    const totalDeductions = deductions.reduce((accumulator, current) => {
      return accumulator + new Number(current.amount || 0)
    }, 0)

    setTotal(totalEarnings - totalDeductions)
  }, [earnings, deductions])

  //functions for earnings table CRUD operations

  const earningsDelete = (index) => {
    setEarnings(earnings.filter((_, i) => i !== index))
  }

  const earningsChange = (e, index, field) => {
    const updatedItems = [...earnings]
    updatedItems[index][field] = e.target.value
    setEarnings(updatedItems)
  }

  const addEarningsRow = () => {
    setEarnings((prev) => [...prev, { earnings: '', amount: '' },])
  }


  //functions for deduction table CRUD operations

  const addDeductionRow = () => {
    setDeductions((prev) => [...prev, { deduction: '', amount: '' },])
  }

  const deductionChange = (e, index, field) => {
    const updatedItems = [...deductions]
    updatedItems[index][field] = e.target.value
    setDeductions(updatedItems)
  }

  const deductionDelete = (index) => {
    setDeductions(deductions.filter((_, i) => i !== index))
  }



  //function to update payslip usestate
  const handleInputChange = (val, field) => {
    setPayslipData((prevData) => ({
      ...prevData,
      [field]: val,
    }));
  }


  //function for validation it checks all fields entered or not
  const validatePayslipData = () => {
    if (!payslipData.title || !payslipData.payslipNo || !imageUrl || !payslipData.payDate || !payslipData.payPeriod || !payslipData.employerDetails || !payslipData.employeeDetails) {
      alert("Please fill in all the required fields.")
      return false
    }
    if (earnings.some(item => !item.earnings || !item.amount)) {
      alert("Please fill in all earnings details.")
      return false;
    }
    if (deductions.some(item => !item.deduction || !item.amount)) {
      alert("Please fill in all deductions details.")
      return false
    }
    return true
  }


  //function to generate pdf

  const generatePdf = () => {

    if (!validatePayslipData()) return

    const payslipHtml = `
        <div style="font-family: Arial, sans-serif; padding: 20px; width: 100%; max-width: 600px; margin: auto; border: 1px solid #ddd;">        
          <h2 style="text-align: center;">${payslipData.title}</h2>
          <div style='display: flex;justify-content: space-between'>
            <div style="display: flex; flex-direction: column; gap: 5px;">
              <div style="display: flex;">
                 <strong>Payslip No:</strong><span>${payslipData.payslipNo}</span>
              </div>
              <div style="display: flex;">
                <strong>Pay Date:</strong> <span>${payslipData.payDate}</span>
              </div>
              <div style="display: flex;">
                 <strong>Pay Period:</strong> <span>${payslipData.payPeriod}</span>
              </div>
           </div>
            <img src=${imageUrl} alt="Sample Image" height="100" width="150" />
          </div>
          <div style="display:flex;">
             <strong>Employer Details:</strong>
             <span>${payslipData.employerDetails}</span>
          </div>
          <div style="display:flex;">
               <strong>Employee Details:</strong>
               <span>${payslipData.employeeDetails}</span>
          </div>
  
          <strong style="display: inline-flex; justify-content: center; align-items: center; width: 100%;">Earnings</strong>
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left; background-color:#D3D3D3">Earnings</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: right; background-color:#D3D3D3">Amount</th>
              </tr>
            </thead>
            <tbody>
              ${earnings
        .map(
          (item) => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.earnings}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${payslipData.currency}${item.amount}.00</td>
                  </tr>`
        )
        .join('')}
            </tbody>
          </table>
  
         <strong style="display: inline-flex; justify-content: center; align-items: center; width: 100%;">Deductions</strong>
          <table style="width: 100%; border-collapse: collapse;">
            <thead>
              <tr>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: left;background-color:#D3D3D3">Deductions</th>
                <th style="border: 1px solid #ddd; padding: 8px; text-align: right;background-color:#D3D3D3">Amount</th>
              </tr>
            </thead>
            <tbody>
              ${deductions
        .map(
          (item) => `
                  <tr>
                    <td style="border: 1px solid #ddd; padding: 8px;">${item.deduction}</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: right;">${payslipData.currency}${item.amount}.00</td>
                  </tr>`
        )
        .join('')}
                <tr>
                    <td style="border: 1px solid #ddd; padding: 8px;background-color:#D3D3D3">Total Pay</td>
                    <td style="border: 1px solid #ddd; padding: 8px; text-align: right;background-color:#D3D3D3">${payslipData.currency}${total}.00</td>
                </tr>
            </tbody>
          </table>
          <div style="display: flex;">
             <strong>Total Pay:</strong><span>${numbersInWords} Rupees Only</span>
          </div>

          <div style="display: flex; justify-content: space-between;margin-top:10px">
             <div style="display: flex;">
                <strong>Employee Signature:</strong><span> ${payslipData.employeeSignatureText}</span>
             </div>
             <div style="display: flex;">
                <strong>Employer Signature:</strong><span> ${payslipData.employerSignatureText}</span>
             </div>
          </div>
          
          <div style="display:flex;justify-content: center; align-items: center;margin-top:20px">
           <strong>Payment Details:</strong>
           <spanp>${payslipData.paymentDetails}</span>
          </div>

          <strong style="display: flex; justify-content: center; align-items:center;margin-top:10px">${payslipData.footerNote}</strong>
        </div>
      `;

    // Use html2pdf to generate and download the PDF
    const options = {
      margin: 10,
      filename: 'invoice.pdf',
      image: { type: 'jpeg', quality: 1 },
      html2canvas: { scale: 8 },
      jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
    };

    // Create a Blob object with the generated HTML and pass it to html2pdf
    const element = document.createElement('div');
    element.innerHTML = payslipHtml;
    html2pdf()
      .from(element)
      .set(options)
      .save('payslip.pdf');
  }


  const handleImageChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      convertToBase64(file);
    }
  };

  // Convert file to base64
  const convertToBase64 = (file) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => {
      setImageUrl(reader.result); // Set base64 encoded image URL
    };
    reader.onerror = (error) => {
      console.error('Error converting image:', error);
    };
  };

  return (
    <div className=''>
      <div className='d-flex'>
        <div className='col-2 d-none d-md-block sidebar'>
          <Sidebar />
        </div>
        <div className='col-10 bg-white p-5'>
          <div className='right_part_payslip'>
            <h2>Payslip Maker</h2>
            <div className='mt-5'>
              {
                imageUrl && (
                  <img src={imageUrl} alt="Company Logo" className='LogoImage' />
                )
              }
            </div>
            <div className='d-flex flex-wrap'>
              <div className='col-6 pay_slip'>
                <div style={{ width: "200px" }}>
                  <label style={{ cursor: 'pointer' }} className='image_label'>
                    <img
                      src='/upload.png'
                      alt="Upload Icon"
                      style={{ height: '20px', width: '20px' }}
                    />
                    <input
                      type="file"
                      accept="image/*"
                      className='d-none'
                      onChange={handleImageChange}
                    />
                    <p className='mt-3'>Company Logo</p>
                  </label>
                </div>
                <div className='d-flex flex-wrap gap-1 mt-3'>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Title</label><Textbox height='50' width='200' setValue={(val) => handleInputChange(val, 'title')} value={payslipData.title} /></div>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Payslip No</label><Textbox height='50' width='200' setValue={(val) => handleInputChange(val, 'payslipNo')} value={payslipData.payslipNo} /></div>
                </div>
                <div className='d-flex mt-3 gap-1 flex-wrap'>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Employer Details</label><TextArea height='100' width='200' setValue={(val) => handleInputChange(val, 'employerDetails')} placeholder='Please enter employer details' /></div>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Employee Details</label><TextArea height='100' width='200' setValue={(val) => handleInputChange(val, 'employeeDetails')} placeholder='Please enter employee details' /></div>
                </div>
                <div className='d-flex mt-3 gap-1 flex-wrap'>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Pay Date</label><Calender setValue={(val) => handleInputChange(val, 'payDate')} /></div>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Pay Period</label><Textbox height='50' width='200' setValue={(val) => handleInputChange(val, 'payPeriod')} value={payslipData.payPeriod} /></div>
                </div>
                <div className='d-flex mt-3 gap-1 flex-wrap'>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Footer Note</label><TextArea height='100' width='200' setValue={(val) => handleInputChange(val, 'footerNote')} value={payslipData.footerNote} /></div>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Payment Details</label><TextArea height='100' width='200' setValue={(val) => handleInputChange(val, 'paymentDetails')} value={payslipData.paymentDetails} /></div>
                </div>
                <div className='d-flex mt-3 flex-wrap gap-1'>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Employee Signature Text</label><Textbox height='50' width='200' setValue={(val) => handleInputChange(val, 'employeeSignatureText')} /></div>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Employer Signature Text</label><Textbox height='50' width='200' setValue={(val) => handleInputChange(val, 'employerSignatureText')} /></div>
                </div>
                <div className='d-flex mt-3 flex-wrap gap-1'>
                  <div className='d-flex flex-column gap-1'><label className='ms-2'>Currency</label><Textbox height='50' width='200' setValue={(val) => handleInputChange(val, 'currency')} value={payslipData.currency} /></div>
                </div>
              </div>
              <div className=''>
                <div className="">
                  <table className="pay-slip-table">
                    <thead>
                      <tr>
                        <th className="table-header">Earnings</th>
                        <th className="table-header">Amount</th>
                        <th className="table-header">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {earnings.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="input-field"
                              type='text'
                              value={item.earnings}
                              onChange={(e) => earningsChange(e, index, 'earnings')}
                            />
                          </td>
                          <td>
                            <input
                              className="input-field ms-1"
                              type='text'
                              value={item.amount}
                              onChange={(e) => earningsChange(e, index, 'amount')}
                            />
                          </td>
                          <td>
                            <FaTrash onClick={() => earningsDelete(index)} className='ms-3 delete' />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button onClick={addEarningsRow}>+</button>
                </div>
                <div className="">
                  <table className="">
                    <thead>
                      <tr>
                        <th className="table-header">Deductions</th>
                        <th className="table-header">Amount</th>
                        <th className="table-header">Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {deductions.map((item, index) => (
                        <tr key={index}>
                          <td>
                            <input
                              className="input-field"
                              type='text'
                              value={item.deduction}
                              onChange={(e) => deductionChange(e, index, 'deduction')}
                            />
                          </td>
                          <td>
                            <input
                              className="input-field ms-1"
                              type='text'
                              value={item.amount}
                              onChange={(e) => deductionChange(e, index, 'amount')}
                            />
                          </td>
                          <td>
                            <FaTrash onClick={() => deductionDelete(index)} className='ms-3 delete' />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                  <button onClick={addDeductionRow}>+</button>

                  <div className='d-flex justify-content-center mt-3 align-items-center gap-5 p-2 total_pay'>
                    <strong>Total Pay</strong>
                    <input type='text' onChange={(e) => setTotal(e.target.value)} value={total} />
                  </div>
                  <div style={{ width: '100%', maxWidth: '500px', height: 'auto', padding: '10px' }}>
                    <p style={{ fontSize: '16px', margin: '0', textAlign: 'center' }}>
                      <strong>Total Pay:</strong> {numbersInWords} Rupees Only
                    </p>
                  </div>

                  <div>
                    <button onClick={generatePdf} className='mt-3 payslip_print'>Print</button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Payslip
